// Mirrors the products-service beans APIImportAreaStatus / APIImportAreaReport /
// APIImportReportCounts. Status is serialized by the backend as the DAO enum name.
export enum ProductImportReportStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  FUNCTIONAL_FAILURE = 'FUNCTIONAL_FAILURE',
  TECHNICAL_FAILURE = 'TECHNICAL_FAILURE',
  RUNNING = 'RUNNING',
}

// UI-only display state layered over the backend status: a successful run that also
// logged warnings is shown as 'WARNING' (orange). The backend never sends this — it is
// derived from a successful status plus a non-zero warningCount. See
// docs/adr/0001-warning-state-is-ui-derived.md.
export type ImportDisplayStatus = ProductImportReportStatus | 'WARNING' | null;

export interface ImportReportCounts {
  processed: number;
  created: number;
  updated: number;
  deleted: number;
  errorCount: number;
  warningCount: number;
}

// One tile on the status board: a known Import Area plus its latest report (if any).
export interface ImportAreaStatus {
  code: string;
  displayName: string;
  sortOrder: number;
  latestStatus: ProductImportReportStatus | null;
  latestBusinessDate: string | null;
  latestRunNumber: number | null;
  latestFinishedAt: string | null;
  counts: ImportReportCounts | null;
  // Full URL to the latest report artifact, or null when the area has never run / stores no key.
  latestReportUrl: string | null;
}

// One row in an area's report history.
export interface ImportAreaReport {
  businessDate: string;
  runNumber: number;
  status: ProductImportReportStatus | null;
  statusMessage: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  counts: ImportReportCounts;
  // Full URL to the report artifact, or null when no artifact key is stored.
  reportUrl: string | null;
}
